export const useMyChatStore = defineStore({
  id: 'myChatStore',
  state: () => ({
    isChatStarted: ref(false),
    isChatModalOpen: false,
    intervalId: null as NodeJS.Timeout | null,
    previousMessageNumber: 0,
    newMessageNumber: 0,
    chatModalStatus: false,
  }),
  actions: {
    initChatForTest() {
      // @ts-ignore
      releasySupportChatModule.InitChat(true);
      setTimeout(function () {
        // @ts-ignore
        releasySupportChatModule.sendMessage('-');
      }, 1000);
      setTimeout(() => this.START_INTERVAL(), 1000);
    },
    ToggleChat() {
      const runtimeConfig = useRuntimeConfig();
      if (runtimeConfig.public.isTestEnvironment && !this.isChatStarted) {
        this.initChatForTest();
        return;
      }
      const cookieChatIsMinimize = useCookie('a2be3m1minimizeWindow');

      if (cookieChatIsMinimize.value == '0') {
        // @ts-ignore
        releasySupportChatModule.minimizeWindow();
      } else if (cookieChatIsMinimize.value == '1') {
        // @ts-ignore
        releasySupportChatModule.openStart();
      } else {
        console.log('*** Invalid cookie value or missing cookie. ****');
      }
    },
    CLEAR_INTERVAL_ID() {
      console.log('clearing interval...', this.intervalId);
      document.body.classList.remove('no-scroll-mobile');
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = null;
      this.isChatStarted = false;
      this.isChatModalOpen = false;
    },
    START_INTERVAL() {
      const id = setInterval(() => {
        console.log('Interval...');
        const cookieChatList = useCookie('a2be3m1indexMessage');
        const cookieChatIsMinimize = useCookie('a2be3m1minimizeWindow');

        if (cookieChatIsMinimize.value == '1') {
          this.chatModalStatus = false;

          // set message number
          this.newMessageNumber = Number(cookieChatList.value);

          document.body.classList.remove('no-scroll-mobile');
        } else {
          if (cookieChatList.value) {
            this.newMessageNumber = 0;
          }

          document.body.classList.add('no-scroll-mobile');

          // set chat modal status
          this.isChatModalOpen = true;
        }
        const cookieChatStarted = useCookie('a2be3m1chatstartedNKI');

        if (cookieChatStarted.value) {
          // set chat status
          this.isChatStarted = true;
          const chatFrame = document.getElementById('chatframe');
          if (chatFrame && chatFrame.innerHTML.trim() === '') {
            // open or init releasy chat
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            releasySupportChatModule.chatstarted
              ? // @ts-ignore
                releasySupportChatModule.openStart()
              : // @ts-ignore
                releasySupportChatModule.InitChat();
          }
        } else {
          // clear interval id
          this.CLEAR_INTERVAL_ID();
        }
      }, 1000);
      // set interval id
      this.intervalId = id;
    },
    STOP_INTERVAL() {
      // clear interval id
      this.START_INTERVAL();
      this.CLEAR_INTERVAL_ID();
    },
  },
  getters: {
    isModalVisable() {
      const cookieChatIsMinimize = useCookie('a2be3m1minimizeWindow');

      if (cookieChatIsMinimize.value == '0' && this.isChatStarted) {
        return true;
      } else {
        return false;
      }
    },
  },
});
